(() => {
  'use strict';
  const labels = document.getElementById('tf-delivery-strings');
  if (!labels) return;
  const strings = JSON.parse(labels.textContent);
  const allowed = new WeakSet();
  let checking = false;
  function proceed(formId) {
    const form = document.getElementById(formId);
    const button = form?.querySelector('[name="checkout"]');
    if (!form || !button || button.disabled) return;
    allowed.add(form);
    form.requestSubmit(button);
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.closest('[data-tf-cart-content]') || event.submitter?.name !== 'checkout') return;
    if (allowed.has(form)) { allowed.delete(form); return; }
    event.preventDefault();
    if (checking) return;
    checking = true;
    const formId = form.id;
    const button = event.submitter, original = button.textContent;
    button.disabled = true; button.textContent = strings.checking;
    try {
      await TFShopify.prepareCheckout();
      const fresh = document.getElementById(formId);
      if (!fresh || fresh.querySelector('[name="checkout"]').disabled) return;
      proceed(formId);
    } catch {
      const error = document.getElementById(formId)?.querySelector('[data-cart-error]');
      if (error) { error.textContent = strings.error; error.hidden = false; }
    } finally {
      checking = false;
      if (button.isConnected) { button.disabled = false; button.textContent = original; }
    }
  });
})();
